import {ApiResourceModel} from './api-resource.model';

export class DataTableSettingModel extends ApiResourceModel {
  public static IRI = '/api/data_table_settings';
  name: string;
  cellIndex: number;
  cellWidth: number;
  user: string;
}
